import PropTypes from "prop-types";
import { memo, useState } from "react";
import { MdClose } from "react-icons/md";

import Button from "./controls/Button";
import { Mask as MaskIcon } from "./icons";

import "./WarningInfo.scss";

const defaultMessage = (
  <>
    <p>
      Sehr geehrte Fahrgäste,
      <br />
      Im öffentlichen Nahverkehr in Bayern gilt die Pflicht zum Tragen einer
      FFP2-Maske – sowohl in allen Verkehrsmitteln als auch in Bahnhöfen.
    </p>
    <p>
      An Bahnsteigen und Haltestellen <u>im Freien</u> entfällt die
      Maskenpflicht.
    </p>
  </>
);

const defaultIcon = <MaskIcon style={{ height: 50, width: 50 }} />;

function WarningInfo({ icon = defaultIcon, message = defaultMessage }) {
  const [isVisible, setVisible] = useState(true);

  return isVisible ? (
    <div id="warning-info">
      <div id="error-icon">{icon}</div>
      <div id="warning-text">{message}</div>
      <Button
        className="close-button"
        onClick={() => {
          setVisible(false);
        }}
      >
        <MdClose focusable={false} />
      </Button>
    </div>
  ) : null;
}

WarningInfo.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.node,
};

export default memo(WarningInfo);
